import {
  // 布局容器
  Container,
  Main,
  Header,
  Footer,
  Aside,
  Row,
  Col,
  // 侧边导航栏
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  // 图标图片
  Icon,
  Image,
  // ui 组件
  Tag,
  Card,
  Tabs,
  Table,
  TableColumn,
  TabPane,
  Collapse,
  CollapseItem,
  Descriptions,
  DescriptionsItem,
  Divider,
  // 表单
  Cascader,
  CascaderPanel,
  DatePicker,
  Form,
  FormItem,
  Input,
  InputNumber,
  Checkbox,
  Select,
  Option,
  OptionGroup,
  Radio,
  RadioGroup,
  RadioButton,
  Button,
  ButtonGroup,
  // 状态
  Empty,
  // 弹窗
  Dialog,
  Drawer,
  Popconfirm,
  Popover,
  Tooltip,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Pagination,
  Upload,
  Switch,
  Link,
  Alert,
  Loading,
  CheckboxGroup,
  CheckboxButton,
  Avatar,
  TimePicker
} from "element-ui";

export default [
  // 布局容器
  Container,
  Avatar,
  Link,
  Main,
  Header,
  Footer,
  Aside,
  Row,
  Col,
  // 侧边导航栏
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  // 图标图片
  Icon,
  Image,
  // ui 组件
  Tag,
  Card,
  Tabs,
  Table,
  TableColumn,
  TabPane,
  Collapse,
  CollapseItem,
  Descriptions,
  DescriptionsItem,
  Divider,
  // 表单
  Cascader,
  CascaderPanel,
  DatePicker,
  Form,
  FormItem,
  Input,
  InputNumber,
  Checkbox,
  CheckboxGroup,
  CheckboxButton,
  Select,
  Option,
  OptionGroup,
  Radio,
  RadioGroup,
  RadioButton,
  Button,
  ButtonGroup,
  // 状态
  Empty,
  // 弹窗
  Dialog,
  Drawer,
  Popconfirm,
  Popover,
  Tooltip,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Pagination,
  Upload,
  Switch,
  Alert,
  Loading,
  TimePicker
];
